import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  ticketBoxMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minHeight: 70,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_50.main,
    borderRadius: '8px',
    cursor: 'pointer',
    padding: '4px 12px',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main + '!important'
          : theme.palette.blue_50.main + '!important'
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 90
    },
    [theme.breakpoints.down('md')]: {
      gap: '6px'
    }
  },
  ticketBoxMessagesmall: {
    minHeight: 52,
    padding: '4px 8px',
    gap: '8px',
    '& $ticketAvatarWrapper': {
      width: 42,
      height: 42
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 52
    }
  },
  ticketBoxMessagemedium: {
    minHeight: 70,
    '& $ticketAvatarWrapper': {
      width: 56,
      height: 56
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 70
    }
  },
  ticketBoxMessagelarge: {},
  ticketBoxAvatar: {
    display: 'flex',
    alignItems: 'center'
  },
  ticketAvatarWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: 70,
    height: 70,

    '& .MuiAvatar-root': {
      width: '100%',
      height: '100%'
    },
    [theme.breakpoints.down('md')]: {
      width: 60,
      height: 60
    }
  },
  ticketAvatar: {
    // width: 45,
    [theme.breakpoints.down('md')]: {
      width: 60,
      height: 60
    }
  },
  ticketAvatarIcon: {
    width: 20,
    height: 20,
    borderRadius: 50,
    padding: 3,
    backgroundColor: theme.palette.green_whatsApp.main,
    position: 'relative',
    right: 25,
    top: 20,
    [theme.breakpoints.up('lg')]: {
      width: 25,
      height: 25
    }
  },

  buttonAcceptTicket: {
    color: theme.palette.green_200.main,
    cursor: 'pointer',
    marginRight: 15
  },

  pendingTicket: {
    cursor: 'pointer'
  },

  noTicketsDiv: {
    display: 'flex',
    height: '100px',
    margin: 40,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },

  noTicketsText: {
    textAlign: 'center',
    color: 'rgb(104, 121, 146)',
    fontSize: '14px',
    lineHeight: '1.4'
  },

  noTicketsTitle: {
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: '600',
    margin: '0px'
  },
  contactBoxLastMessage: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: '8px'
  },

  contactNameWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 !important',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between'
    }
  },

  contactName: {
    display: 'block',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontWeight: '600',
    fontSize: '.8rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // maxWidth: '340px',
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.up('lg')]: {
      fontSize: '1rem',
      fontWeight: '600'
    }
  },
  contactHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0
  },
  contactBox: {
    flex: 1,
    minWidth: 0,
    width: '100%'
    // marginRight: '8px',
    // [theme.breakpoints.down('lg')]: {
    //   maxWidth: 240
    // },
    // [theme.breakpoints.up('lg')]: {
    //   maxWidth: 470
    // },
    // [theme.breakpoints.up('xl')]: {
    //   maxWidth: 600
    // },
    // [theme.breakpoints.down('sm')]: {
    //   maxWidth: 370
    // }
  },
  boxInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end', // Alinha conteúdo à direita
    gap: '4px',
    minWidth: '65px',
    flexShrink: 0,
    marginLeft: 'auto'
  },

  closed: {
    color: theme.palette.red_100.main
  },

  lastMessageTime: {
    fontSize: '.7rem',
    color: theme.palette.gray_300.main
  },

  closedBadge: {
    alignSelf: 'center',
    justifySelf: 'flex-end',
    marginRight: 32,
    marginLeft: 'auto'
  },

  contactWhatsappName: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '12px',
    fontStyle: 'italic',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    width: '100%'
  },

  contactLastMessage: {
    fontSize: 12,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    width: '100%'
  },
  reportTicketDetails: {
    display: 'flex',
    gap: '8px',
    width: '100%',
    fontSize: '11px',
    overflow: 'hidden',
    '& span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },

  newMessagesCount: {
    top: 15,
    right: 10
  },

  badgesContainer: {
    width: '100%',
    height: '100%'
  },

  badgeStyle: {
    color: theme.palette.white_100.main,
    backgroundColor: theme.palette.green_200.main,
    padding: '0 5px !important',
    height: '16px',
    minWidth: '16px'
  },

  acceptButton: {
    position: 'absolute',
    right: '108px'
  },

  ticketQueueColor: {
    flex: 'none',
    width: '8px',
    height: '100%',
    position: 'absolute',
    top: '0%',
    left: '0%',
    backgroundColor: theme.palette.white_100.main
  },

  ticketInfo: {
    position: 'relative',
    top: 0
  },

  tagsWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '4px',
    marginTop: '4px'
  },

  tag: {
    color: theme.palette.white_100.main,
    fontSize: '10px',
    fontWeight: '500',
    textTransform: 'uppercase',
    borderRadius: '4px',
    height: '18px'
  },

  ticketBadge: {
    display: 'flex',
    gap: '4px'
  },

  radiusdot: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiBadge-badge': {
      fontSize: 10
    }
  },

  presence: {
    color: theme.mode === 'light' ? 'green' : 'lightgreen',
    fontWeight: 'bold'
  },
  botIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  botIcon: {
    color: theme.palette.blue_300.main,
    marginTop: 8
  },
  sliceTags: {
    fontWeight: '600',
    color: theme.palette.blue_300.main
  },

  contactBoxConnectionAndUser: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1, // Ocupa todo o espaço disponível à esquerda
    minWidth: 0 // CRUCIAL para o truncate funcionar nos filhos
  },
  reportTableRow: {
    cursor: 'pointer',
    '& .MuiTableCell-root': {
      fontSize: '13px',
      padding: '8px 12px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      [theme.breakpoints.down('sm')]: {
        fontSize: '11px',
        padding: '6px 8px'
      }
    },
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark'
        ? theme.palette.dark_400.main + '!important'
        : theme.palette.blue_50.main + '!important'
    }
  },
  reportTableCell: {
    borderBottom: '1px solid ' + (theme.palette.type === 'dark' ? theme.palette.dark_stroke.main : theme.palette.gray_stroke.main)
  },
  reportTagsCell: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  boxAttendant: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    backgroundColor: theme.palette.blue_50.main,
    border: '1px solid ' + theme.palette.blue_100.main,
    borderRadius: '4px',
    color: theme.palette.blue_300.main,
    padding: '0 4px',
    height: '15px',
    // width: '120px', // Largura fixa que comporta bem ~15 caracteres
    // minWidth: '120px', // Garante que não encolha com 1 letra
    maxWidth: '120px', // Garante que não cresça
    whiteSpace: 'nowrap', // Impede quebra de linha
    overflow: 'hidden', // Esconde o que sobrar (segurança)
    textOverflow: 'ellipsis', // Adiciona "..." se por acaso passar de 15
    textAlign: 'center',

    '& span': {
      textTransform: 'uppercase',
      fontSize: '.75rem',
      margin: 0,
      padding: 0,
      lineHeight: '16px' // Centraliza verticalmente o texto
    }
  },
  iconNotification: {
    cursor: 'pointer',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  boxLastMessage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    gap: '2px'
  }
}))
